export enum SeasonTableFilterTypes {
  Gender = "Gender",
  AgeGroup = "AgeGroup",
  Status = "Status",
  Standard = "Standard",
  CompetitionName = "CompetitionName",
}
